import { message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  deleteKit,
  refreshTableKits,
  setIsKitForUpdate,
  setKitForUpdate,
} from "../../../redux";
import { DataKits } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useKits } from "./useKits";

const { confirm } = Modal;

export const useTableKits = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tableProps } = useKits();

  const changeKitForUpdate = (val: DataKits) => {
    dispatch(setIsKitForUpdate(true));
    dispatch(setKitForUpdate(val));
    navigate(`/kits/${val.id}`);
  };

  const changeNavToKitsProducts = (id: number) => {
    navigate(`/kits/${id}`);
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar el Kit con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar kit" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar kit",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await deleteKit(valId)
          .then((res) => {
            dispatch(refreshTableKits(true));
            if (res[0]?.name) {
              message.success(`Se ha borrado con éxito el Kit con id:${valId}`);
            } else if (res) {
              console.log({ res });
              message.error(`${res}`);
            }
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            message.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  return {
    changeKitForUpdate,
    changeNavToKitsProducts,
    showDeleteConfirm,
  };
};
